import _ from 'lodash';
import { connect } from 'react-redux';
import { search, invalidate } from '../../modules/retailPricing/pricingRequest';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state, ownProps) => {
	let triagePricingRequests = undefined;
	let pendingPricingRequests = undefined;
	let invalidPricingRequests = undefined;
	let completePricingRequests = undefined;
	if (state.pricingRequests.byStatus) {
		const { triage, pending, invalid, issued } = state.pricingRequests.byStatus;
		if (triage) {
			triagePricingRequests = _.map(triage, (id) => state.maps.pricingRequest[id]);
		}
		if (pending) {
			pendingPricingRequests = _.map(pending, (id) => state.maps.pricingRequest[id]);
		}
		if (invalid) {
			invalidPricingRequests = _.map(invalid, (id) => state.maps.pricingRequest[id]);
		}
		if (issued) {
			completePricingRequests = _.map(issued, (id) => state.maps.pricingRequest[id]);
		}
	}

	let pricingRequest;
	let pricingRequestId;

	if (ownProps.pricingRequest) {
		pricingRequest = ownProps.pricingRequest;
		pricingRequestId = pricingRequest.pricingRequestId;
	} else {
		pricingRequestId = ownProps.pricingRequestId
			? ownProps.pricingRequestId
			: _.get(ownProps, ['match', 'params', 'pricingRequestId']);
		pricingRequest = _.get(state.maps, ['pricingRequest', pricingRequestId]);
	}

	const canMakeUpdates = !!_.get(state.auth.authUser, ['permissions', 'canMakeUpdates'], false);
	return {
		pricingRequest,
		pendingPricingRequests,
		triagePricingRequests,
		invalidPricingRequests,
		completePricingRequests,

		userMap: state.maps.user,
		stationMap: state.maps.station,
		gasBuddyPriceMap: state.maps.gasBuddyPrice,
		canMakeUpdates,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			searchPricingRequests: search,
			invalidatePricingRequest: invalidate,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
